export default "__VITE_ASSET__C0sxKs_2__"